export default function createCheckoutIdempotencyKey() {
  const randomBytes = crypto.getRandomValues(new Uint8Array(16));
  const randomPart = Array.from(randomBytes, (byte) =>
    byte.toString(16).padStart(2, '0'),
  ).join('');

  return `checkout-${Date.now().toString(36)}-${randomPart}`;
}
